/// <amd-module name="Agile/Assets/AgileAssets" />
export const enum AgileAssetPaths {
    GeneralHubError = "ms.vss-work-web/agile-assets/Content/hub-error-general.svg",
    ConfigurationRequired = "ms.vss-work-web/agile-assets/Content/configuration-required.svg",
    NoResultsFound = "ms.vss-work-web/agile-assets/Content/no-results-found.svg",
    GetStartedWithSprints = "ms.vss-work-web/agile-assets/Content/zerodata-get-started-with-sprint.svg",
    NoWorkScheduled = "ms.vss-work-web/agile-assets/Content/zerodata-no-work-scheduled.svg"
}
